export function normalizeListResponse(data) {
  if (Array.isArray(data)) {
    return { items: data, meta: null };
  }
  return { items: data?.items ?? [], meta: data?.meta ?? null };
}

export default normalizeListResponse;
